import { useQuery } from "@tanstack/react-query";
import { meetingsApi } from "../../api/workspace-meetings.api";
import { useAuthStore } from "../../store/auth.store";
import { JoinMeeting } from "./GoogleMeet";
export function MeetingReferenceDetails({ id }: { id: string }) {
  const school = useAuthStore((s) => s.activeSchoolId),
    user = useAuthStore((s) => s.user?.id);
  const query = useQuery({
    queryKey: ["meeting-reference-details", school, user, id],
    queryFn: () => meetingsApi.get(id),
    staleTime: 0,
    gcTime: 0,
    retry: false,
    refetchInterval: 30000,
  });
  if (query.isError)
    return (
      <span className="meeting-reference-details">Détails indisponibles</span>
    );
  if (!query.data)
    return (
      <span className="meeting-reference-details">
        Chargement des horaires…
      </span>
    );
  const meeting = query.data;
  const format = (value: string) =>
    new Date(value).toLocaleString("fr-FR", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      timeZone: meeting.timeZone || undefined,
    });
  return (
    <span
      className="meeting-reference-details"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 6,
        fontSize: 12,
        margin: "8px 0",
      }}
    >
      <span>Début : {format(meeting.startsAt)}</span>
      {meeting.endsAt && <span>Fin : {format(meeting.endsAt)}</span>}
      {meeting.timeZone && <small>{meeting.timeZone}</small>}
      <JoinMeeting id={id} />
    </span>
  );
}
